<template>
	<div>
		<div class="container-fluid">
			<div class="row">
				<div class="col-xl-12">
					<ejs-rangenavigator style='display:block;color:red;'
															align='center'
															id='datetimeLW'
															background="transparent"
															color="white"
															:width='width'
															theme="Dark"
															:dataSource='dataSource'
															:majorGridLines='majorGridLines'
															animationDuration=500
															:labelStyle="labelStyle"
															xName='xData'
															yName='yData'
															:changed='changed'
															:tooltip="tooltip"
															:navigatorStyleSettings='navigatorStyleSettings'>
					</ejs-rangenavigator>
				</div>
<!--				<div class="col-xl-12 pt-5 pb-3">-->
<!--					<div class="row">-->
<!--						<div class="col-xl-6">-->
<!--							<div class="text-center">-->
<!--								Total Business Days: <span id="workingcount"></span>-->
<!--							</div>-->
<!--						</div>-->
<!--						<div class="col-xl-6">-->
<!--							<div class="text-center">-->
<!--								Total Weekend Days: <span id="weekendcount"></span>-->
<!--							</div>-->
<!--						</div>-->
<!--					</div>-->
<!--				</div>-->
			</div>
		</div>
	</div>
</template>
<script>
import Vue from "vue";
import { Browser } from "@syncfusion/ej2-base";
import { RangeNavigatorPlugin, AreaSeries, DateTime, RangeTooltip } from "@syncfusion/ej2-vue-charts";
import { GetDateTimeData } from "../../plugins/data-service";
Vue.use(RangeNavigatorPlugin);
export default Vue.extend({
	data: function() {
		return {
			dataSource: [
				{ xData: 0, yData: 0 }, { xData: 2, yData: 0 },
				{ xData: 4, yData: 0 }, { xData: 6, yData: 0 },
				{ xData: 8, yData: 0 }, { xData: 10, yData: 0 },
				{ xData: 12, yData: 0 }, { xData: 14, yData: 0 },
				{ xData: 16, yData: 0 }, { xData: 18, yData: 0 },
				{ xData: 20, yData: 0 }, { xData: 22, yData: 0 },
				{ xData: 24, yData: 0 }, { xData: 26, yData: 0 },
				{ xData: 28, yData: 0 }, { xData: 30, yData: 0 },
			],
			width:"100%",
			navigatorStyleSettings: {
				thumb: {
					type: "Rectangle",
					border: { width: 1, color: '#1ED365'},
				}
			},
			majorGridLines:{
				width: 54,
				color: 'blue',
			},
			labelStyle: {
				color: 'white'
			},
			tooltip: { 
				enable: true, 
				displayMode: 'Always', 
				fill:'#484E69', 
				opacity: 0.6, 
				textStyle:{ style: 'Italic', color:'white'}
			},
		};
	},
	provide: {
		rangeNavigator: [DateTime, AreaSeries, RangeTooltip]
	},
	created() {
	},
	methods: {
		changed: function(args) {
			let currentDate = new Date(+args.start);
			let workingDaysCount = 0;
			let holidaysDaysCount = 0;
		}
	}
});
</script>
<style lang="scss" scoped>
#control-container {
	padding: 0px !important;
}

#container {
	transform: translateY(25%);
}
#datetimeLW {
	height: 86px;
	background-color: transparent;
}
</style>
